import { Component, OnDestroy } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { MatSelectionListChange } from '@angular/material/list';
import { IAddress } from '@bciti/types';
import { ToastrService } from 'ngx-toastr';
import { of, Subject } from 'rxjs';
import { catchError, take, takeUntil, tap } from 'rxjs/operators';
import { AddressService } from 'src/app/services/address/address.service';

@Component({
    selector: 'app-address-search-dialog',
    templateUrl: './address-search-dialog.component.html',
    styleUrls: ['./address-search-dialog.component.scss'],
})
export class AddressSearchDialogComponent implements OnDestroy {
    private destroy$ = new Subject();

    display: 'search' | 'results' = 'search';

    loading = false;

    results: IAddress[] = [];

    query: string;

    form = new FormGroup({
        address: new FormControl(undefined, [Validators.required]),
    });

    constructor(private addressService: AddressService, private toastrService: ToastrService, private dialogRef: MatDialogRef<AddressSearchDialogComponent>) {}

    handleAddressFormSubmit(query: string) {
        this.results = [];
        this.loading = true;
        this.query = query;
        this.addressService
            .getAddressQuery(query)
            .pipe(
                takeUntil(this.destroy$),
                take(1),
                tap((response) => {
                    this.results = response;
                    this.display = 'results';
                    this.loading = false;
                }),
                catchError((error) => {
                    this.toastrService.error(error?.error?.messages[0]);
                    this.results = [];
                    this.display = 'results';
                    this.loading = false;
                    return of([]);
                }),
            )
            .subscribe();
    }

    viewForm(): void {
        this.display = 'search';
    }

    resultToString(address: IAddress): string {
        return `${address.number} ${address.unit} ${address.street}, ${address.city}, ${address.province}, ${address.postCode}`;
    }

    selectAddress(event: MatSelectionListChange): void {
        this.form.patchValue({
            address: {
                ...event.options[0].value,
                direction: event.options[0].value.direction ?? '',
                typeStreet: event.options[0].value.typeStreet ?? '',
            },
        });
    }

    saveSelectedAddress(): void {
        if (this.form.valid) {
            this.dialogRef.close(this.form.value.address);
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
